import { Divider, Grid, Paper, Skeleton, Stack, Typography } from "@mui/material"
import React from "react"
import { AdjustmentCouponUse } from "../../Objects/AdjustmentCouponUse"

export interface AdjustmentCouponUseListProps {
    adj_coupon_use?: AdjustmentCouponUse[]
}
const AdjustmentCouponUseList: React.FC<AdjustmentCouponUseListProps> = ({
    adj_coupon_use
}) => {
    return (
        <Paper
            variant="outlined"
            sx={{
                p: 2
            }}
        >
            <Stack
                spacing={1}
            >
                {adj_coupon_use ? adj_coupon_use.map((adjustment, index) => (
                    <Grid container key={index}
                        sx={{
                            px: 2
                        }}
                    >
                        <Grid item xs={10} sm={5}>
                            <Typography textAlign="left">{adjustment.item}</Typography>
                        </Grid>
                        <Grid item xs={2} sm={2}>
                            <Typography textAlign="right">×{adjustment.number}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={5}>
                            <Typography textAlign="right">{adjustment.charge.toLocaleString()} Pt</Typography>
                        </Grid>
                    </Grid>
                )) : (
                    <Skeleton variant="rectangular" height={50} />
                )}
                {adj_coupon_use && adj_coupon_use.length > 0 &&
                    <Divider />
                }
                <Grid container
                    sx={{
                        px: 2
                    }}
                >
                    <Grid item xs={10} sm={5}>
                        <Typography textAlign="left" color="primary" fontWeight="bold">利用ポイント合計</Typography>
                    </Grid>
                    <Grid item xs={2} sm={2}>
                        <Typography textAlign="right">×{adj_coupon_use ? adj_coupon_use.reduce<number>((prev, adjustment) => prev + adjustment.number, 0) : "-"}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={5}>
                        <Typography textAlign="right">{adj_coupon_use ? adj_coupon_use.reduce<number>((prev, adjustment) => prev + adjustment.charge, 0).toLocaleString() : "-"} Pt</Typography>
                    </Grid>
                </Grid>
            </Stack>
        </Paper>
    )
}

export default AdjustmentCouponUseList